import SignalContent from "../signal_content";
import { setLampFlash } from "./signallamp_controller";
import { updateAndGetAndApplyComponentSetting } from "./update_and_get_and_apply_settings";

/**
 * ブラウザ（ローカル）にパトランプ色設定のスタイルを反映する。
 * @param {SignalContent} self
 */
const setLampColorStyle = (self: SignalContent) => {
  const lampColors = [];
  for (let i = 0; i < 4; i++) {
    let color: string = "#cccccc";
    let className: string = "";
    if (typeof self.keyColors[i] !== "undefined") {
      color = self.keyColors[i];
      className = `lamp-${color}`;
    }
    const backColor = `background-color: ${color}`;
    let nowFlush = false;
    if (self.lampColors.length > 0 && self.lampColors[i].flush) {
      nowFlush = self.lampColors[i].flush;
    }
    lampColors.push({
      className,
      backColor,
      flush: nowFlush,
    });
  }
  self.lampColors = lampColors;
};

/**
 * パトランプの設定情報をデータベースに保存する。
 * @param {SignalContent} self
 * @returns {Promise<void>}
 */
export async function saveSignallampSetting(self: SignalContent) {
  try {
    const result = await updateAndGetAndApplyComponentSetting(self);
  } catch (e) {
    alert(self.$t("message.failedToSaveSettings"));
    console.error(e);
  }
  try {
    // インターバル処理のクリア　最新データ１件の取得のためクリア再設定は不要。
    clearInterval(self.reloadEvent);
    // 設定内容に応じたランプ色を設定
    if (self.selectDeviceId) {
      await setLampFlash(self, self.authStores);
    }
    // ブラウザ（ローカル）にパトランプ色設定の変更を反映する
    setLampColorStyle(self);

    await setLampFlash(self, self.authStores);
    self.reloadEvent = setInterval(function() {
      setLampFlash(self, self.authStores);
    }, 5000);
  } catch (e) {
    alert(self.$t("message.failedToGetData"));
    console.error(e);
  }
}
